import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const releaseTotesFromFulfillmentGroups = {
  name: "releaseTotesFromFulfillmentGroups" as const,
  input: z.object({ toteIds: z.array(zExt.objectId()) }),
  output: z.object({
    success: z.boolean(),
    releasedToteCount: z.number(),
    releasedFulfillmentGroupCount: z.number(),
  }),
};
